<script>
export default {
  name: 'CustomerTrackingLaboralGuide',
  props: ['show'],
};
</script>

<template>
  <v-dialog :value="show" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Guión de llamadas para laboral</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text style="padding-top: 0" class="laboral-guide">
        <div class="llamada">
          <h2>
            <span class="emoji">📞</span>
            Primera llamada del año – Evaluación y necesidades de la empresa
          </h2>

          <div class="objetivo">
            <h3>
              <span class="emoji">🎯</span>
              Objetivo:
            </h3>
            <ul>
              <li>Evaluar la experiencia con la asesoría y detectar áreas de mejora.</li>
              <li>Conocer la situación actual de la empresa y posibles cambios estratégicos.</li>
              <li>Ofrecer asesoramiento laboral adaptado a sus necesidades.</li>
            </ul>
          </div>

          <div class="seccion">
            <h3>
              <span class="emoji">📜</span>
              Guion de la llamada:
            </h3>

            <ol>
              <li>
                <p class="destacado">Introducción</p>
                <p>
                  "Hola [nombre del contacto], soy [tu nombre] de OpenGes. Quería llamarte porque en
                  OpenGes estamos reforzando nuestro acompañamiento a empresas como la tuya. Nos
                  gustaría saber cómo ha ido el negocio en estos últimos meses y ver cómo podemos
                  ayudarte a optimizar la gestión laboral. ¿Tienes unos minutos para charlar?"
                </p>
                <p><em>Si el cliente está ocupado:</em></p>
                <p>"No hay problema, dime cuándo te viene mejor y te llamo en otro momento."</p>
              </li>

              <li>
                <p class="destacado">Preguntas clave para entender la situación de la empresa</p>
                <ul>
                  <li>¿Cómo ha evolucionado la empresa en estos últimos meses?</li>
                  <li>
                    ¿Ha habido cambios en la plantilla, nuevas contrataciones o reestructuraciones?
                  </li>
                  <li>
                    ¿Estáis satisfechos con la información y asesoramiento que os proporcionamos?
                    ¿Hay algo que os gustaría mejorar?
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Asesoramiento y valor añadido</p>
                <ul>
                  <li>Gestión laboral: Bonificaciones para la contratación, ERTE, teletrabajo.</li>
                  <li>
                    Preguntar si tienen PRL, reconocimientos médicos de empleados, registro
                    retributivo digital, ver con ellos las tablas salariales que aplican por encima.
                  </li>
                  <li>
                    En sociedades, revisar si el socio remunera su trabajo (nómina o factura).
                    Comprobar el cargo del administrador si es gratuito o no para ver si corresponde
                    nómina.
                  </li>
                  <li>Ver si están obligados a tener la póliza de accidentes.</li>
                  <li>
                    Preguntar por la cuota reta que pagan para actualizar en nómina si la tiene como
                    salario en especie. Revisar este punto en Excel de control interno de Openges
                    (debería estar anotado).
                  </li>
                  <li>
                    Ver si han realizado cursos por formación o están interesados en realizarlos,
                    comentarles los créditos que tienen a su disposición.
                  </li>
                  <li>
                    Comentarles todas las obligaciones laborales que tienen: como tener implantado
                    el Plan de Prevención del Acoso Laboral, Implementación Protocolo de Desconexión
                    Digital, Ley de protección de datos, etc. y por si quieren aprovechar los
                    créditos de formación, para formar a los empleados.
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Preguntas clave sobre el servicio prestado por OpenGes</p>
                <ul>
                  <li>¿Cómo ha sido tu experiencia con nuestro servicio en los últimos meses?</li>
                  <li>
                    ¿Sientes que tienes toda la información y apoyo que necesitas en el área
                    laboral?
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Cierre y próximos pasos</p>
                <p>
                  "Gracias por tu tiempo, [nombre]. Me llevo anotado [resumen de necesidades o temas
                  clave] y vamos a [acción que tomará la asesoría]. Si surge algo más, estamos aquí
                  para ayudaros. ¡Seguimos en contacto!"
                </p>
              </li>
            </ol>
          </div>
        </div>

        <div class="llamada">
          <h2>
            <span class="emoji">📞</span>
            Segunda llamada del año – Seguimiento y planificación estratégica
          </h2>

          <div class="objetivo">
            <h3>
              <span class="emoji">🎯</span>
              Objetivo:
            </h3>
            <ul>
              <li>Hacer seguimiento de los temas tratados en la primera llamada.</li>
              <li>Ayudar a la empresa en la planificación fiscal y financiera de cierre de año.</li>
              <li>Informar sobre novedades legales y oportunidades relevantes.</li>
            </ul>
          </div>

          <div class="seccion">
            <h3>
              <span class="emoji">📜</span>
              Guion de la llamada:
            </h3>

            <ol>
              <li>
                <p class="destacado">Introducción</p>
                <p>
                  "Hola [nombre del contacto], soy [tu nombre] de OpenGes. Hace unos meses hablamos
                  sobre [tema tratado en la primera llamada] y quería saber cómo ha evolucionado la
                  situación. También quería comentarte algunas novedades laborales que pueden
                  afectar a la empresa y ver si podemos ayudaros con la planificación de cierre de
                  año. ¿Tienes un momento?"
                </p>
                <p><em>Si no hubo temas pendientes:</em></p>
                <p>
                  "Quería hablar contigo porque estamos ayudando a nuestros clientes con la revisión
                  de su situación laboral, y quería chequear si podemos hacer algún ajuste en
                  vuestra planificación para reducir costes o aprovechar oportunidades."
                </p>
              </li>

              <li>
                <p class="destacado">Preguntas clave para el cierre del año</p>
                <ul>
                  <li>Comprobaciones de contratos en el año.</li>
                  <li>
                    Llamar a aquellas empresas, que detectemos que tienen contratos fijos
                    discontinuos que puedan superar el periodo de temporalidad y a aquellas empresas
                    que viendo que ha tenido muchos contratos temporales en el año podamos
                    enfocarles que el tipo de contrato debe ser indefinido por defecto.
                  </li>
                  <li>
                    Ofrecerles explicación sobre los permisos que pueden tener sus trabajadores por
                    encima.
                  </li>
                  <li>
                    Mostrarles las posibilidades de retribución flexible por si están interesados en
                    implantarlo en su empresa.
                  </li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Información de valor</p>
                <ul>
                  <li>Cambios en normativa laboral que afecten al negocio.</li>
                  <li>Seguros de responsabilidad civil, accidente, etc.</li>
                  <li>Retribución socios/administradores.</li>
                </ul>
                <p></p>
              </li>

              <li>
                <p class="destacado">Cierre y próximos pasos</p>
                <p>
                  "Me alegro de haber podido ponerte al día, [nombre]. Me quedo con [resumen de
                  puntos clave]. Si necesitas que revisemos algo más en detalle, dime y lo vemos
                  juntos. ¡Un placer hablar contigo!"
                </p>
              </li>
            </ol>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.laboral-guide {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
h1 {
  color: #2c3e50;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
}
h2 {
  color: #2980b9;
  margin-top: 30px;
}
.llamada {
  background-color: #f8f9fa;
  border-left: 4px solid #3498db;
  padding: 15px;
  margin-bottom: 30px;
  border-radius: 0 5px 5px 0;
}
.objetivo {
  background-color: #e8f4f8;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.objetivo h3 {
  margin-top: 0;
  color: #2980b9;
}
.objetivo ul {
  margin-bottom: 0;
}
.seccion {
  margin-bottom: 20px;
}
.seccion h3 {
  color: #2c3e50;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
.seccion ol {
  padding-left: 20px;
}
.seccion ul {
  list-style-type: circle;
  padding-left: 20px;
}
.destacado {
  font-weight: bold;
  color: #2980b9;
}
.emoji {
  font-size: 1.5em;
  margin-right: 10px;
  vertical-align: middle;
}
</style>
